import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { UserTypeService } from '../services/user-type.service';
import { UserType } from '../models/auth.types';
/**
 * Guard para verificar que el usuario tenga un tipo específico
 * @param requiredUserType Tipo de usuario requerido
 * @returns true si el usuario tiene el tipo correcto, false en caso contrario
 */
export function createUserTypeGuard(requiredUserType: UserType): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    const userTypeService = inject(UserTypeService);
    const router = inject(Router);

    // Verificar tipo de usuario
    const currentUserType = userTypeService.getCurrentUserType();
    
    if (!currentUserType) {
      // Si no hay tipo de usuario establecido, intentar obtenerlo
      return userTypeService.getUserProfileAndType().then(result => {
        if (!result) {
          router.navigate(['/auth/login']);
          return false;
        }

        const { userType } = result;
        userTypeService.setCurrentUserType(userType);

        if (userType === requiredUserType) {
          return true;
        } else {
          // Redirigir al dashboard correcto
          userTypeService.redirectToDashboard(userType);
          return false;
        }
      });
    } else {
      if (currentUserType === requiredUserType) {
        return true;
      } else {
        // Redirigir al dashboard correcto
        userTypeService.redirectToDashboard(currentUserType);
        return false;
      }
    }
  };
}

/**
 * Guard para verificar que el usuario sea un cliente
 */
export const ClientGuard: CanActivateFn = createUserTypeGuard(UserType.CLIENTE);

/**
 * Guard para verificar que el usuario sea un abogado
 */
export const LawyerGuard: CanActivateFn = createUserTypeGuard(UserType.ABOGADO);
